// extracted by mini-css-extract-plugin
export default {"layout":"f2a8043c2f ce032e491e a8738731b2","h_slide":"_16105b7cec","category":"_2350e7defa a3dd9ee5fe _0d613894bc"};